<template>
  <v-sheet class="mt-5 pa-5" tile>
    <v-subheader class="text-h5 pa-0 pb-4">{{
      $t('DASHBOARD.TASK_REPORTS')
    }}</v-subheader>

    <task-reports-list :items="transformedTasks" @show="showTask" />

    <v-dialog v-model="dialog" persistent max-width="1400px">
      <view-event-task
        v-if="taskId"
        :id="taskId"
        @updated="cancelDialogAndRefresh"
        @removed="cancelDialogAndRefresh"
        @cancel="cancelDialog"
      ></view-event-task>
    </v-dialog>
  </v-sheet>
</template>

<script>
import { keyBy } from 'lodash';
import { mapActions } from 'vuex';
import i18nRefreshData from '@/modules/_global/mixins/i18nRefreshData';

export default {
  name: 'TaskReports',

  components: {
    ViewEventTask: () =>
      import('@/modules/plannings/components/Event/ViewEventTask'),
    TaskReportsList: () =>
      import('@/modules/statistic/components/TaskReports/TaskReportsList')
  },

  mixins: [i18nRefreshData],

  data() {
    return {
      tasks: [],
      taskStatuses: [],
      dialog: false,
      taskId: null
    };
  },

  computed: {
    transformedStatuses() {
      return keyBy(this.taskStatuses, 'id');
    },

    transformedTasks() {
      return this.tasks.map(task => {
        return {
          ...task,
          status: this.transformedStatuses[task.status_id]
        };
      });
    }
  },

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('planning', ['getTaskStatuses']),
    ...mapActions('statistic', ['retrieveTaskReports']),

    refreshData() {
      this.getTaskStatuses()
        .then(({ data }) => {
          this.taskStatuses = data.data;
        })
        .then(this.retrieveTaskReports)
        .then(({ data }) => {
          this.tasks = data.data;
        })
        .catch(error => {
          console.log('Error', error.message);
        });
    },

    showTask({ id }) {
      this.taskId = id;
      this.dialog = true;
    },

    cancelDialog() {
      this.dialog = false;
      this.taskId = null;
    },

    cancelDialogAndRefresh() {
      this.cancelDialog();
      this.refreshData();
    }
  }
};
</script>
